import {useMemberStore} from "@/services/store/memberStore";

document.addEventListener("DOMContentLoaded", function () {
    device.check();
});

export const commonUi = {
    init: function () {
        this.inputHandlers();
        this.commonGnb();
        this.keyboardFocus.init();
    },

    // 헤더 고정
    commonGnb: function () {
        let prevSclTop =
            window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        document.addEventListener("scroll", function () {
            const nowSclTop =
                window.scrollY ||
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            const sclDirection = nowSclTop > prevSclTop ? "down" : "up";
            const sclDistance = Math.abs(nowSclTop - prevSclTop);
            const elArray = [];
            const header = document.querySelector("#header");

            if (header) elArray.push(header);

            if (elArray.length)
                fixedClassChk(elArray, nowSclTop, sclDirection, sclDistance);

            prevSclTop = nowSclTop;
        });

        function fixedClassChk(elArray, nowSclTop, sclDirection, sclDistance) {
            elArray.forEach(function (item) {
                const itemEnd = getOffset(item).top + item.offsetHeight;
                const container = document.querySelector("#container");

                if (nowSclTop > itemEnd) {
                    item.classList.add("fixed");
                    container.classList.add("fixed");
                    if (sclDistance > 5) {
                        if (sclDirection === "down") {
                            item.classList.add("is-up");
                            container.classList.add("headerFixed");
                            // 06-20 gnb닫기
                            document.body.classList.remove("gnbOpen");
                            // 06-20 알람리스트 팝업 닫기
                            // 06-25 pc 사이즈 일때만 적용하도록 수정
                            const wrapElement = document.getElementById("wrap");
                            if (wrapElement.classList.contains("pcSize")) {
                                const alertListPop =
                                    document.getElementById("alertListPop");
                                if (alertListPop) {
                                    document
                                        .getElementById("alimCloseBtn")
                                        .click();
                                }
                            }
                        } else {
                            item.classList.remove("is-up");
                            container.classList.remove("headerFixed");
                        }
                    }
                } else {
                    item.classList.remove("fixed", "is-up");
                    container.classList.remove("headerFixed");
                }
            });
        }

        // header fixed 위치
        function getOffset(element) {
            let $el = element;
            let $elX = 0;
            let $elY = 0;
            let isSticky = false;
            while (
                $el &&
                !Number.isNaN($el.offsetLeft) &&
                !Number.isNaN($el.offsetTop)
                ) {
                let $style = window.getComputedStyle($el);
                // const $matrix = new WebKitCSSMatrix($style.transform);
                if ($style.position === "sticky") {
                    isSticky = true;
                    $el.style.position = "static";
                }
                $elX += $el.offsetLeft;
                // $elX += $matrix.m41; //translateX
                $elY += $el.offsetTop;
                // $elY += $matrix.m42;  //translateY
                if (isSticky) {
                    isSticky = false;
                    $el.style.position = "";
                    if ($el.getAttribute("style") === "")
                        $el.removeAttribute("style");
                }
                $el = $el.offsetParent;
                if ($el !== null) {
                    $style = window.getComputedStyle($el);
                    $elX += parseInt($style.borderLeftWidth);
                    $elY += parseInt($style.borderTopWidth);
                }
            }
            return {left: $elX, top: $elY};
        }

        // 10-10 skip 네비게이션(pc에서만 사용)
        // function getFirstFocusableElement(element) {
        //     const focusableElements = element.querySelectorAll(
        //         'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        //     );
        //     return focusableElements[0];
        // }
        //
        // function skipNavi(e) {
        //     e.preventDefault()
        //     const containerCont = document.getElementById('container')
        //     const firstFocusable = getFirstFocusableElement(containerCont)
        //
        //     if (firstFocusable) {
        //         firstFocusable.focus();
        //     } else {
        //         containerCont.setAttribute("tabindex", "-1");
        //         containerCont.focus();
        //     }
        //
        //     containerCont.scrollIntoView({behavior: "smooth"});
        // }
        //
        // const skipLink = document.querySelector('.skip-nav a')
        //
        // skipLink.addEventListener("click", skipNavi)
        //
        // skipLink.addEventListener('keydown', function (e) {
        //     if (e.key === 'Enter' || e.key === ' ') {
        //         skipNavi(e)
        //     }
        // })
    },

    // input 수정 소스
    inputHandlers: function () {
        const InputBox = document.querySelectorAll(".input-box");
        const InputDel = document.querySelectorAll(".input-del");
        const showToggle = document.querySelectorAll(".show-toggle");
        const customChk = document.querySelectorAll(
            ".radio input, .checkbox input"
        );

        // 인풋 readonly 및 disabled 추가
        function handleInputElements(selector, parentClass) {
            const inputs = document.querySelectorAll(selector);

            inputs.forEach((input) => {
                const parentDiv = input.parentElement;
                parentDiv.classList.add(parentClass);

                const elementsToHide = parentDiv.querySelectorAll(".input-del");
                elementsToHide.forEach((element) => {
                    element.setAttribute("tabindex", "-1");
                    element.classList.add("hide");
                    element.blur();
                });
            });
        }

        handleInputElements("input[readonly]", "readonly");
        handleInputElements("input[disabled]", "disabled");

        const updateInputBoxState = (inputBoxDiv, inputElement) => {
            if (inputElement.value.trim() !== "") {
                inputBoxDiv.classList.add("hasValue");
                setElementsTabIndex(inputBoxDiv, "0");
                const InputDel = inputElement.parentElement.querySelector('.input-del')
                if (InputDel) {
                    InputDel.setAttribute('aria-hidden', false)
                }
            } else {
                inputBoxDiv.classList.remove("hasValue");
                setElementsTabIndex(inputBoxDiv, "-1");
                const InputDel = inputElement.parentElement.querySelector(".input-del");
                if (InputDel) {
                    setTimeout(() => {
                        InputDel.setAttribute("aria-hidden", true);
                    }, 300)
                }
            }

            // WA-09-02 disabled 형태 추가
            if (
                inputElement.hasAttribute("readonly") ||
                inputElement.hasAttribute("disabled")
            ) {
                inputBoxDiv.classList.add("readOnly");
            } else {
                inputBoxDiv.classList.remove("readOnly");
            }
        };

        const setElementsTabIndex = (inputBoxDiv, index) => {
            const elementsToHide = inputBoxDiv.querySelectorAll(".input-del");
            elementsToHide.forEach((element) => {
                element.setAttribute("tabindex", index);
            });
        };

        // 09-03 가상키패드 이슈대응 새로운 함수 추가
        function adjustBottomFixedPosition(bottomFixedElement) {
            const keyboardHeight =
                window.innerHeight - window.visualViewport.height;
            bottomFixedElement.style.bottom = `${keyboardHeight}px`;
        }

        function resetBottomFixedPosition(bottomFixedElement) {
            bottomFixedElement.style.bottom = "0";
        }

        InputBox.forEach((inputBoxDiv) => {
            const inputElement = inputBoxDiv.querySelector("input");
            // 08-06 앱 버전 및 모바일 디바이스에서 가상 키패드 올라오는 상황 대응
            const bottomFixedElement = document.querySelector(
                ".bottom-fixed:not(.pop-wrap .bottom-fixed)"
            );
            const isIosOrAndroid = ["ios", "android", "app-Device"].some(
                (cls) => document.documentElement.classList.contains(cls)
            );

            if (inputElement) {
                inputElement.addEventListener("focus", () => {
                    inputBoxDiv.classList.add("focus");
                    // 08-06 앱 버전 및 모바일 디바이스에서 가상 키패드 올라오는 상황 대응
                    if (bottomFixedElement && isIosOrAndroid) {
                        adjustBottomFixedPosition(bottomFixedElement);
                    }
                });

                inputElement.addEventListener("blur", () => {
                    inputBoxDiv.classList.remove("focus");
                    // 08-06 앱 버전 및 모바일 디바이스에서 가상 키패드 올라오는 상황 대응
                    if (bottomFixedElement && isIosOrAndroid) {
                        resetBottomFixedPosition(bottomFixedElement);
                    }
                });

                updateInputBoxState(inputBoxDiv, inputElement);

                inputElement.addEventListener("input", () => {
                    updateInputBoxState(inputBoxDiv, inputElement);
                });
            }
        });

        // 08-23 스크롤 이벤트 리스너 추가
        // window.addEventListener('scroll', () => {
        //     const bottomFixedElement = document.querySelector('.bottom-fixed:not(.pop-wrap .bottom-fixed)')
        //     const isIosOrAndroid = ['ios', 'android', 'app-Device'].some((cls) =>
        //         document.documentElement.classList.contains(cls)
        //     )
        //
        //     const scrollPosition = window.innerHeight + window.scrollY
        //     const documentHeight = document.body.offsetHeight
        //     // console.log('스크롤 포지션:', scrollPosition, '전체 높이:', documentHeight)
        //
        //     if (bottomFixedElement && isIosOrAndroid) {
        //         if (scrollPosition >= documentHeight - 50) {
        //             bottomFixedElement.classList.add('noFixed')
        //         } else {
        //             bottomFixedElement.classList.remove('noFixed')
        //         }
        //     }
        // })

        InputDel.forEach((btn) => {
            btn.addEventListener("click", () => {
                const inputBoxDiv =
                    btn.closest(".input-box") ||
                    btn.parentElement.parentElement.parentElement; // 06-25 input-box 안에 요소만 찾게
                const inputElement = btn.parentElement.previousSibling;
                if (inputElement) {
                    inputElement.value = "";
                    inputBoxDiv.classList.remove("hasValue");
                    updateInputBoxState(inputBoxDiv, inputElement); // 06-26 인풋에 상태에 따라 업데이트
                    //btn.setAttribute('tabindex', '-1')
                }
            });
        });

        showToggle.forEach((btn) => {
            btn.addEventListener("click", () => {
                const inputElement = btn
                    .closest(".input-box")
                    .querySelector("input");
                if (inputElement.type === "password") {
                    inputElement.type = "text";
                    btn.setAttribute("aria-label", "비밀번호 보이기");
                    btn.classList.remove("off");
                    btn.classList.add("on");
                } else {
                    inputElement.type = "password";
                    btn.setAttribute("aria-label", "비밀번호 숨기기");
                    btn.classList.remove("on");
                    btn.classList.add("off");
                }
            });
        });

        // customChk.forEach((input) => {
        //     // 09-20 input요소에 선택됨 상태 추가
        //     // 09-23 라디오 타입 추가
        //     const label = input.closest("label");
        //     let statusSpan = label.querySelector("span.blind");
        //     if (!statusSpan) {
        //         // 09-20 blind 클래스가 없으면 생성
        //         statusSpan = document.createElement("span");
        //         statusSpan.className = "blind";
        //         label.appendChild(statusSpan);
        //     }
        //
        //     // 09-23 라디오 버튼 로직 분리
        //     if (input.type === "radio") {
        //         const radioGroup = document.querySelectorAll(
        //             `input[name="${input.name}"]`
        //         );
        //         radioGroup.forEach((radio) => {
        //             const radioLabel = radio.closest("label");
        //             const radioStatusSpan =
        //                 radioLabel.querySelector("span.blind");
        //             if (radioStatusSpan) {
        //                 radioStatusSpan.textContent = radio.checked
        //                     ? "선택됨"
        //                     : "선택안됨";
        //             }
        //         });
        //     } else {
        //         statusSpan.textContent = input.checked ? "선택됨" : "선택안됨";
        //     }
        //
        //     input.addEventListener("change", () => {
        //         const label = input.closest("label");
        //         const siblingLabels = label.querySelectorAll(".lbl");
        //         siblingLabels.forEach((lbl) =>
        //             lbl.classList.add("focus-visible")
        //         );
        //
        //         // 09-20 삭제
        //
        //         // 09-23 라디오 버튼 로직 분리
        //         if (input.type === "radio") {
        //             const radioGroup = document.querySelectorAll(
        //                 `input[name="${input.name}"]`
        //             );
        //             radioGroup.forEach((radio) => {
        //                 const radioLabel = radio.closest("label");
        //                 const radioStatusSpan =
        //                     radioLabel.querySelector("span.blind");
        //                 if (radioStatusSpan) {
        //                     radioStatusSpan.textContent = radio.checked
        //                         ? "선택됨"
        //                         : "선택안됨";
        //                 }
        //             });
        //         } else {
        //             statusSpan.textContent = input.checked
        //                 ? "선택됨"
        //                 : "선택안됨";
        //         }
        //     });
        //     input.addEventListener("focus", () => {
        //         const siblingLabels = input
        //             .closest("label")
        //             .querySelectorAll(".lbl");
        //         siblingLabels.forEach((label) =>
        //             label.classList.add("focus-visible")
        //         );
        //     });
        //
        //     input.addEventListener("blur", () => {
        //         const siblingLabels = input
        //             .closest("label")
        //             .querySelectorAll(".lbl");
        //         siblingLabels.forEach((label) =>
        //             label.classList.remove("focus-visible")
        //         );
        //     });
        // });
    },
    // 08-14 탭 포커스(키보드만 아웃라인 나오게 변경)
    keyboardFocus: {
        usingKeyboard: false,

        init: function () {
            this.addEventListeners();
            this.setupFocusableElements();
        },

        addEventListeners: function () {
            document.addEventListener("keydown", (e) => {
                if (e.key === "Tab") {
                    this.usingKeyboard = true;
                    document.body.classList.add("tabFocus");
                }
            });

            document.addEventListener("mousedown", () => {
                this.usingKeyboard = false;
                document.body.classList.remove("tabFocus");
            });
        },

        setupFocusableElements: function () {
            const focusableElements = document.querySelectorAll(
                'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            focusableElements.forEach((el) => {
                el.addEventListener("focus", () => {
                    if (this.usingKeyboard) {
                        el.classList.add("keyboard-focus");
                    }
                });

                el.addEventListener("blur", () => {
                    el.classList.remove("keyboard-focus");
                });
            });
        },
    },
};

// skip-nav 함수 추가
export function skipNav() {
    // 10-10 skip 네비게이션(pc에서만 사용)
    function getFirstFocusableElement(element) {
        const focusableElements = element.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        return focusableElements[0];
    }

    function skipNavi(e) {
        e.preventDefault();
        const containerCont = document.getElementById("container");
        const firstFocusable = getFirstFocusableElement(containerCont);

        if (firstFocusable) {
            firstFocusable.focus();
        } else {
            containerCont.setAttribute("tabindex", "-1");
            containerCont.focus();
        }

        containerCont.scrollIntoView({behavior: "smooth"});
    }

    const skipLink = document.querySelector(".skip-nav a");

    skipLink.addEventListener("click", skipNavi);

    skipLink.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
            skipNavi(e);
        }
    });
}

export function toggleGnb() {
    const menuButton = document.querySelector(".btn-menu");
    const wrap = document.getElementById("wrap");
    const commonGnb = document.querySelector(".commonGnb");
    const menuClose = commonGnb.querySelector('.btn-close')

    // WA-09-02 gnbOpen 클래스 토글 관리
    const isGnbOpenAfterToggle = document.body.classList.toggle("gnbOpen");

    if (menuButton) {
        // WA-09-02 aria 텍스트 수정
        const newLabel = isGnbOpenAfterToggle
            ? "전체메뉴 닫기"
            : "전체메뉴 열기";
        menuButton.setAttribute("aria-label", newLabel);

        // WA-09-02 wrap의 aria-hidden 속성 관리를 비동기적으로 처리
        setTimeout(() => {
            if (window.innerWidth < 1025) {
                if (isGnbOpenAfterToggle) {
                    wrap.setAttribute('inert', '')
                    commonGnb.setAttribute('aria-hidden', false)
                    commonGnb.setAttribute('tabindex', '0')
                    menuButton.setAttribute('aria-hidden', true)

                    // WA-01-16 (아이폰 포커스 이슈)
                    if (menuClose) {
                        menuClose.focus()
                    }
                } else {
                    wrap.removeAttribute('inert')
                    // WA-10-11 GNB 접근성 수정
                    commonGnb.setAttribute('aria-hidden', true)
                    commonGnb.setAttribute('tabindex', '-1')
                    menuButton.removeAttribute('aria-hidden')
                    menuButton.focus()
                }
            } else {
                // WA-09-02 화면 크기가 1025px 이상일 때는 항상 aria-hidden 제거
                wrap.removeAttribute('inert')
            }
        }, 500)
    }

    //06-20 알람리스트 팝업 닫기
    togglePop("alertListPop", false, false, false);
}

// 클래스를 추가/제거 공통 스크립트
function toggleClass(element, className, add) {
    if (element) {
        if (add) {
            element.classList.add(className);
        } else {
            element.classList.remove(className);
        }
    }
}

// WA-09-04 열린 팝업 갯수 전역변수 추가
let openPopupCount = 0;
// WA-09-04 다른 팝업 순서 스택
let popupStack = [];
// 09-12 팝업 초기화
let isInitialized = false;

// 09-11 새로운 함수: z-index 업데이트
function updateZIndex() {
    popupStack.forEach((item, index) => {
        item.modal.style.zIndex = 200 + index;
    });
}

export function togglePop(
    elementId,
    shouldShow,
    isTooltip = false,
    options = {}
) {
    const {
        shouldFocusTrigger = true,
        openNextPopup = null,
        useTimeout = true,
    } = options;

    const modal = document.getElementById(elementId);
    // const triggerElement = document.querySelector(
    //     `[aria-controls="${elementId}"]`
    // );
    let triggerElement
    // data-popup-trigger 속성이 있는 요소 찾기
    const hasTriggerElements = document.querySelector(`[aria-controls="${elementId}"][data-popup-trigger]`)

    if (hasTriggerElements) {
        // data-popup-trigger가 있는 경우 data-active 요소 찾기
        triggerElement = document.querySelector(`[aria-controls="${elementId}"][data-active="true"]`)
    } else {
        // 기존 로직 유지
        triggerElement = document.querySelector(`[aria-controls="${elementId}"]`)
    }
    // WA-09-02 wrap요소 aria-hidden="true" 속성 추가
    const wrap = document.getElementById("wrap");
    // 10-18 메뉴 버튼 리셋 추가

    // 09-12 팝업 초기화 로직 추가
    if (!isInitialized) {
        initializePopups();
        isInitialized = true;
    }

    function initializePopups() {
        const popups = document.querySelectorAll(".popup");
        openPopupCount = 0;

        popups.forEach((popup) => {
            if (
                popup.classList.contains("show") &&
                !isTooltipType(popup) &&
                !isAlertListPopType(popup)
            ) {
                openPopupCount++;
            }
        });
        // 10-14 pub 수정
        // updateWrapInert();
    }

    // // 10-02 리사이즈 알람팝업 수정
    // function handleResize() {
    //     initializePopups()
    //     if (openPopupCount === 0) {
    //         wrap.removeAttribute('aria-hidden')
    //     }
    // }
    //
    // window.addEventListener('resize', handleResize)

    function isTooltipType(popup) {
        return popup.classList.contains("tooltipType");
    }

    function isAlertListPopType(popup) {
        return popup.classList.contains() && window.innerWidth >= 1024;
    }

    // function updateWrapInert() {
    //     if(openPopupCount === 0) {
    //         wrap.removeAttribute('inert')
    //     } else {
    //         if (document.body.classList.contains('lock')) {
    //             wrap.setAttribute("inert", "");
    //         }
    //     }
    // }
    // 10-14 pub 수정
    // function updateWrapInert() {
    //     // wrap요소가 있을경우에만 동작
    //     const wrap = document.querySelector("#wrap");

    //     if (wrap) {
    //         if (openPopupCount === 0) {
    //             // 10-03 inert 속성 교체
    //             wrap.removeAttribute("aria-hidden");
    //         } else {
    //             if (document.body.classList.contains("lock")) {
    //                 // 10-03 inert 속성 교체
    //                 wrap.setAttribute("aria-hidden", "true");
    //             }
    //         }
    //     }
    // }

    // 09-03 alertListPop 클래스 1024 이상일때만
    const isAlertListPop = document.querySelector(
        ":not(#header) #alertListPop"
    );

    // WA-09-02  popup 클래스를 가진 요소의 자식 요소 중 pop-bg-close 클래스를 가진 요소에 속성 추가
    const popups = document.querySelectorAll(".popup");
    popups.forEach((popup) => {
        const closeBtns = popup.querySelectorAll(".pop-bg-close");
        closeBtns.forEach((btn) => {
            btn.setAttribute("aria-hidden", "true");
        });
    });

    // 08-07 마우스 휠 버튼 이벤트 조정
    // 전역 변수로 이벤트 리스너 참조를 저장
    if (typeof window.wheelClickListener === "undefined") {
        window.wheelClickListener = null;
        window.isModalOpen = false;
    }

    const handleWheelClick = (event) => {
        if (window.isModalOpen && event.button === 1) {
            event.preventDefault();
            return false;
        }
    };

    /// WA-09-02: 마지막으로 포커스된 요소를 저장하기 위한 변수
    // WA-09-04 trapFocus 기능 삭제

    const closeModal = () => {
        toggleClass(modal, "show-end", false);
        // WA-09-02: tabindex 속성 변경
        modal.setAttribute("tabindex", "-1");

        // WA-09-02 wrap요소 aria-expanded 제거 & 위치 변경
        if (isTooltip) {
            triggerElement.setAttribute("aria-expanded", "false");
            // WA-10-02 툴팁 닫혔을때 툴팁 버튼에 inert 속성 삭제
            triggerElement.removeAttribute("inert");
        }
        // 10-03 얼럿 수정
        if (isAlertListPop && window.innerWidth <= 1024) {
        }
        const finishClosing = () => {
            toggleClass(modal, "show", false);

            if (triggerElement) {
                // WA-09-02 aria 속성 위치 변경
                modal.setAttribute("aria-hidden", "true");

                if (shouldFocusTrigger) {
                    triggerElement.focus();
                }
            }

            if (typeof openNextPopup === "function") {
                openNextPopup();
            }

            // 10-08 열려있는 전체 팝업 체크
            const popupArray = Array.isArray(popups)
                ? popups
                : Array.from(popups);

            // 10-08 show 클래스 있는 팝업 체크
            const hasVisblePopups = () => {
                return popupArray.some((popup) =>
                    popup.classList.contains("show")
                );
            };
            // WA-09-04 팝업 여러개 열려있음 다름 팝업에 inert 속성 변경
            popupArray.forEach((popup) => {
                if (popup !== modal && popup.classList.contains("show")) {
                    // popup.removeAttribute('inert')
                    popup.removeAttribute("inert");
                }
            });
            // 10-08 팝업에 show 클래스가 있는 팝업이 없다면...
            if (!hasVisblePopups()) {
                wrap.removeAttribute("aria-hidden");
                toggleClass(document.body, "lock", false);
                // 메뉴 버튼 활성화(알람 팝업 열리면 잠겼던)
                document.querySelector('.btn-menu')?.removeAttribute('inert')
            }

            // 08-07 마우스 휠 버튼 이벤트 조정
            // 모달이 닫힐 때 휠 버튼 활성화
            window.isModalOpen = false;

            // 이벤트 리스너 제거
            if (window.wheelClickListener) {
                document.removeEventListener(
                    "mousedown",
                    window.wheelClickListener
                );
                window.wheelClickListener = null;
            }

            // WA-09-02: 모달이 닫힐 때 원래 포커스되어 있던 요소로 포커스 이동
            // WA-09-04 trapFocus 기능 삭제

            // WA-09-04 열린 팝업 수를 감소(0이 될때까지)
            if (!isTooltip || !isAlertListPop) {
                openPopupCount = Math.max(0, openPopupCount - 1);
            }

            // WA-09-04 다른 팝업내에 트리거로 포커스 이동
            popupStack = popupStack.filter((item) => item.modal !== modal);

            // 09-11 새로 추가된 부분: z-index 업데이트
            updateZIndex();

            // WA-09-04 위치 변경
            if (!isTooltip && !isAlertListPop) {
                // WA-09-02 wrap요소 aria-hidden="true" 속성 추가
                wrap.removeAttribute("aria-hidden");
            }

            // WA-09-04 다른 팝업내에 트리거로 포커스 이동
            if (shouldFocusTrigger && triggerElement) {
                triggerElement.focus();
            } else if (popupStack.length > 0) {
                const lastPopup = popupStack[popupStack.length - 1];
                const focusElement = lastPopup.modal.querySelector(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                if (focusElement) {
                    focusElement.focus();
                }
            }
        };

        if (useTimeout) {
            setTimeout(finishClosing, 500);
            // WA-09-02 arai 속성 위치 변경
        } else {
            finishClosing();
        }
    };

    if (shouldShow) {
        if (elementId !== 'pageMoveLoadingPop' && elementId !== 'loadingPopup' && elementId !== 'logoutPop') {
            const store = useMemberStore();
            store.member.openPopupId = elementId;
        }
        // WA-09-02: 모달이 열리기 전 현재 포커스된 요소 저장
        // WA-09-04 trapFocus 기능 삭제

        // WA-09-04 팝업을 열 때 카운트를 증가
        if (!isTooltip && !isAlertListPop) {
            openPopupCount++;
        }

        popupStack.push({modal, triggerElement});

        // 새로 추가된 부분: z-index 업데이트
        updateZIndex();

        // 09-03 pc 타입일때 body에 lock 클래스 추가하지 않기
        if (!isTooltip) {
            toggleClass(document.body, "lock", true);
            // wrap.setAttribute('aria-hidden', 'true')
            // 09-04 aria-hidden > inert 속성 변경
            // 09-09 wrap이 있을때만 수정
            const setInertAttribute = () => {
                const wrap = document.getElementById("wrap");
                if (wrap) {
                    wrap.removeAttribute("aria-hidden");
                }
            };

            setInertAttribute();
        }
        toggleClass(modal, "show", true);
        modal.removeAttribute("aria-hidden");
        // WA-09-02: tabindex 속성 변경
        modal.setAttribute("tabindex", "0");

        const openModal = () => {
            toggleClass(modal, "show-end", true);
            // wrap.setAttribute("aria-hidden", true);
            toggleClass(document.body, 'lock', true)
            if (isTooltip) {
                toggleClass(document.body, 'lock', false)
            }
            // WA-09-02 wrap요소 aria-expanded 제거
            if (triggerElement) {
                if (isTooltip) {
                    triggerElement.setAttribute("aria-expanded", "true");
                    // WA-10-02 툴팁 열렸을때 툴팁 버튼에 inert 속성 추가
                    triggerElement.setAttribute("inert", "");
                    wrap.setAttribute('aria-hidden', false)
                }
            }

            // WA-09-04 팝업 여러개 열려있음 다름 팝업에 inert 속성 변경
            popups.forEach((popup) => {
                popup.removeAttribute("inert");
                if (
                    popup !== modal &&
                    popup.classList.contains("show") &&
                    !popup.classList.contains("loading") &&
                    !popup.classList.contains("move-loading")
                ) {
                    popup.setAttribute("inert", "");
                    //popup.setAttribute("aria-hidden", true);
                }
            });

            // WA-09-24 포커스 트랩 로직 시작
            // WA-09-26 로직 변경 시작
            const getFocusableElements = () =>
                Array.from(
                    modal.querySelectorAll(
                        'a[href], button:not(:disabled), textarea, input[type="password"],input[type="number"], input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])'
                    )
                ).filter((el) => {
                    // button 요소가 아니거나, button이지만 disabled가 아닌 경우만 포함
                    const isValidButton =
                        el.tagName.toLowerCase() !== "button" || !el.disabled;

                    const isVisible =
                        window.getComputedStyle(el).display !== "none";

                    return isValidButton && isVisible;
                });

            // 첫 번째 요소에 포커스
            // WA-12-10 포커스 로직 변경
            const focusFirstElement = () => {
                const focusableElements = getFocusableElements()

                setTimeout(() => {
                    if (focusableElements.length === 0) {
                        modal.focus()
                    } else {
                        focusableElements[0].focus()
                    }

                    if (!isTooltip) {
                        wrap.setAttribute("aria-hidden", true);
                    }

                }, 400)

            }

            focusFirstElement();

            const handleKeyDown = (e) => {
                if (e.key === "Tab") {
                    const focusableElement = getFocusableElements();
                    const firstElement = focusableElement[0];
                    const lastElement =
                        focusableElement[focusableElement.length - 1];
                    if (e.shiftKey) {
                        if (document.activeElement === firstElement) {
                            e.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        if (document.activeElement === lastElement) {
                            e.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            };

            modal.addEventListener("keydown", handleKeyDown);
            // WA-09-24 포커스 트랩 끝

            // WA-09-02: 모달이 열릴 때 포커스 트랩 설정
            // WA-09-04 trapFocus 기능 삭제

            // 08-07 마우스 휠 버튼 이벤트 조정
            // 모달이 열릴 때 휠 버튼 비활성화
            window.isModalOpen = true;

            // 이벤트 리스너 추가 (이미 있다면 제거 후 다시 추가)
            if (window.wheelClickListener) {
                document.removeEventListener(
                    "mousedown",
                    window.wheelClickListener
                );
            }
            window.wheelClickListener = handleWheelClick;
            document.addEventListener("mousedown", window.wheelClickListener);
        };

        if (useTimeout) {
            setTimeout(openModal, 100);
        } else {
            openModal();
        }
    } else {
        if (modal.classList.contains("show-end")) {
            closeModal();
        }
    }
    // 10-14 pub 수정
    //updateWrapInert();

    // WA-09-02: 모달이 제거될 때 모든 이벤트 리스너 제거
    return () => {
        document.removeEventListener("mousedown", handleWheelClick);
        // WA-09-04 trapFocus 기능 삭제
    };
}

// 전체 동의 체크박스
// app.directive('toggle-checked', {
//   beforeMount(el) {
//     const input = el.querySelector('input[type="checkbox"]')
//     if (input) {
//       input.addEventListener('change', () => {
//         if (input.checked) {
//           el.classList.add('checked')
//         } else {
//           el.classList.remove('checked')
//         }
//       })
//     }
//   }
// })
// 디바이스 체크
const device = {
    check: function () {
        isDevice.check();
    },
};
const isDevice = {
    window: () => /windows/i.test(navigator.userAgent),
    mac: () => /macintosh/i.test(navigator.userAgent),
    chrome: () =>
        /chrome/i.test(navigator.userAgent) &&
        !/edge/i.test(navigator.userAgent) &&
        !/opr/i.test(navigator.userAgent),
    firefox: () => /firefox/i.test(navigator.userAgent),
    opera: () => /opera|OPR/i.test(navigator.userAgent),
    safari: () =>
        /safari/i.test(navigator.userAgent) &&
        !/chrome/i.test(navigator.userAgent) &&
        !/opr/i.test(navigator.userAgent),
    edge: () => /edge/i.test(navigator.userAgent),
    msie: () => /rv:11.0|msie/i.test(navigator.userAgent),
    ie11: () => /rv:11.0/i.test(navigator.userAgent),
    ie10: () => /msie 10.0/i.test(navigator.userAgent),
    ie9: () => /msie 9.0/i.test(navigator.userAgent),
    ie8: () => /msie 8.0/i.test(navigator.userAgent),
    android: () => /android/i.test(navigator.userAgent),
    ios: () => /iphone|ipad|ipod/i.test(navigator.userAgent),
    any: function () {
        return this.window() || this.mac();
    },
    check: function () {
        const html = document.documentElement;
        Object.entries(this).forEach(([key, func]) => {
            if (
                typeof func === "function" &&
                key !== "check" &&
                key !== "any" &&
                func()
            ) {
                html.classList.add(key);
            }
        });
    },
};
